import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=8f339502&scoped=true"
import script from "./BaseListItem.vue?vue&type=script&lang=js"
export * from "./BaseListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=8f339502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f339502",
  null
  
)

export default component.exports